import { html, type TemplateResult } from "lit";
// Hendrick Motorsports / Valvoline / Blood Cancer United lockup — one asset
// covering Figma 421:142 in full (273 x 48.41), dividers included.
//
// The middle mark lost its "Global" line on 2026-08-17 at the client's request.
// It was done by deleting that word's six paths from this SVG rather than by
// dropping in the logo they sent, which is the POSITIVE version: its wordmark is
// #00316d, the exact colour of the bar behind it. The mark that is here is
// Valvoline's reversed lockup — white wordmark, white keylines splitting the V —
// and is what the dark bar needs. If the flat V ever has to replace it, it needs
// the reversed asset, not a recolour.
import logoLockup from "./logo-lockup.svg";

import "./nav.scss";

export interface NavProps {
  /** Overrides the bundled logo lockup. */
  readonly logo: string;
  /** Where the CTA points. */
  readonly ctaHref: string;
}

/**
 * Fixed-height top bar. Figma desktop 421:139 (1728x82 — a 78px navy bar plus a
 * 4px gradient strip); mobile 428:956 (402x99, lockup only).
 */
export function renderNav({ logo, ctaHref }: NavProps): TemplateResult {
  return html`
    <div class="valvoline-nav">
      <!-- __bar carries the full-bleed navy; __inner holds the gutters. -->
      <div class="valvoline-nav__bar">
        <div class="valvoline-nav__inner">
          <img
            class="valvoline-nav__logo"
            src=${logo || logoLockup}
            alt="Hendrick Motorsports, Valvoline and Blood Cancer United"
            width="273"
            height="49"
          />

          <p class="valvoline-nav__tagline">Donate & Make an Impact</p>

          <a class="valvoline-nav__cta" href=${ctaHref} target="_blank" rel="noopener">Donate</a>
        </div>
      </div>
      <div class="valvoline-nav__strip" aria-hidden="true"></div>
    </div>
  `;
}
